import axios from "axios";

export const sendFeedback = async (module_id: string, page_id, meta, feedback) => {
    try {
        const res = await axios.post("/messaging/feedback", { module_id, page_id, meta, feedback });

        return res.data;
    } catch (err) {
        throw err;
    }
};
